import memoize from 'js/lib/memoize';

import { memoizedCourseProgressPromise as memoizedOpenCourseCourseProgressPromise } from 'pages/open-course/common/data/courseProgress';

import CourseProgress from 'bundles/in-course-stores/models/courseProgress';

const fullCourseProgressPromise = function (courseSlug: $TSFixMe) {
  const promise = memoizedOpenCourseCourseProgressPromise(courseSlug).then(function (progressData) {
    return new CourseProgress(progressData);
  });
  promise.done();
  return promise;
};

export default fullCourseProgressPromise;
export const memoizedCourseProgressPromise = memoize(fullCourseProgressPromise);
